var p2pdates = function () {
    var _toggleRadioButton = $("[data-toggle]"),
        _toggleContent = $('[data-toggle-content]'),
        _dayContainer = $('[data-id="p2pdays"]'),
        _dayDateInput = _dayContainer.find('input[type="date"]'),
        _dayListItems = _dayContainer.find('li[data-hide-on-load="true"]'),
        _dayList = _dayContainer.find('ol'),
        _totalPrice = $("[data-total-price]"),
        _resetPriceDropdowns = $("[data-reset-price]");

    _toggleContent.each(function () {

        if ($(this).attr("data-hide-on-load") == 'true') {
            $(this).addClass('x');
        }
    });

    _toggleRadioButton.on('change', function () {

        var button = $(this),
			what = button.data("toggle"),
            elem = $('[data-toggle-content=' + what + ']');

        _toggleContent.addClass('x');

        if ($(this).is(':checked')) {

            elem.removeClass('x');
        }

        _totalPrice.addClass('x');
    });

    var datepickerParent = _dayDateInput.parent(),
    nonNativeDatepicker = datepickerParent.hasClass("m-datepicker"),
    closeButtonMarkup = '<button type="button" data-id="clear" class="btn-dateclear"><span class="visually-hidden">Clear</span><span class="icon-close"></span></button>';

    if (nonNativeDatepicker) {
        datepickerParent.after(closeButtonMarkup);
    } else {
        _dayDateInput.after(closeButtonMarkup);
    }

    _dayList.after('<button type="button" data-id="add" formnovalidate class="btn btn-tertiary btn-dateadd btn-icon btn-back"><span class="icon-plus-grey"></span>Add date</button>');
    _dayListItems.addClass('x');

    var _addButton = $('[data-id="add"]');
    $('[data-id="clear"]').on("click", function () {
        
        var parent = $(this).parent('li');

        parent.addClass('x').
        find('input').prop('value', false);

        _addButton.prop('disabled', 'disabled', false);

        _totalPrice.addClass('x');
    });

    _addButton.on("click", function () {
       
        var dateContainer = $('li.x:first');

        dateContainer.removeClass('x');

        if (_dayList.find('li.x').length < 1) {
            $(this).attr('disabled', 'disabled');
        }

        _totalPrice.addClass('x');
    });

    _resetPriceDropdowns.on('change', function() {
        _totalPrice.addClass("x");
    });
}